import { handleError } from './handler-error';

export const createThunk = thunk => (dispatch, getState, args) => thunk(handleError(dispatch), getState, args);
